export function init(obj) {
    var res = {}
    for (let key in obj) {
        if (!key.startsWith('_')) {
            res[key] = obj[key]
        }
    }
    return res
}

export function copy(obj) {
    var res = {}
    for (let key in obj) {
        res[key] = obj[key]
    }
    return res
}

export function mapping(src, dst, extList = []) {
    for (let key in src) {
        if (key in dst && !extList.includes(key)) {
            dst[key] = src[key]
        }
    }
}

export function mappingNotNull(src, dst, extList = []) {
    for (let key in src) {
        if (key in dst && !extList.includes(key)) {
            if (src[key]) {
                dst[key] = src[key]
            }
        }
    }
}

export const toFileSize = (byte, format) => {
    const bw = Number(byte) || 0
    const units = ['T', 'G', 'M', 'KB', 'B']
    const max = units.length - 1
    let p = max,
        q = bw
    while (p > -1) {
        q = q / 1024
        if (q < 1 || units[p] === format) break
        p--
    }
    return `${(bw / Math.pow(1024, max - p)).toFixed(2).replace(/\.00$/, '')}${units[p]}`
}
// export function getSaveObj() {
//     const obj = {}
//     for(let key in this){
//         if(!key.startsWith('_')){
//             obj[key] = this[key]
//         }
//     }
//     return obj 
// }

//按钮共通点击延迟
export function setLoading() {
    return setTimeout(() => {
        }, 1000)
}